import { create } from "zustand";

interface SidebarState {
  isCollapsed: boolean;
  sidebarWidth: number;
  toggleCollapsed: () => void;
  setCollapsed: (collapsed: boolean) => void;
  setSidebarWidth: (width: number) => void;
}

export const useSidebarStore = create<SidebarState>((set) => ({
  isCollapsed: false,
  sidebarWidth: 200,
  toggleCollapsed: () => set((state) => ({ isCollapsed: !state.isCollapsed })),
  setCollapsed: (collapsed: boolean) => set({ isCollapsed: collapsed }),
  setSidebarWidth: (width: number) => set({ sidebarWidth: width }),
}));

